import React from "react";
import styles from "./Button3.module.css";


const Button3 = ({ text, onClick, Icon }) => {
  return (
    <button className={styles.btn} onClick={onClick}>
      <Icon size={23} color="#F2692B" />
      {text}
    </button>
  );
};

export default Button3;